/** @param {{ inquiryKind?: string } | null | undefined} row */
export function isCustomServiceWizardRequest(row) {
  return row?.inquiryKind === 'custom';
}

/** Wizard flow requests (reusable for matching providers / inquiries). */
export function isWizardFlowServiceRequest(row) {
  return !isCustomServiceWizardRequest(row);
}
